import { ProductCategoryModalInfo } from './ProductCategoryModalInfo';
import { RewardButtons } from '../../project/reward/RewardButtons';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../project/product-category-modal/product-category-modal-actions';
import styles from './product-category-modal.module.less';
import { ScrollableModalStickyBottom } from '../scrollable-modal-sticky-bottom/ScrollableModalStickyBottom';

export const ProductCategoryModal = () => {
    const dispatch = useDispatch();

    const { product, options, buyButtonConfig, isOpen } = useSelector((state) => state.productCategoryModal);

    const onModalClose = () => {
        dispatch(closeModal());
    };
    const footerComponent = buyButtonConfig && (
        <RewardButtons {...buyButtonConfig} wrapperClassName={styles.buttonsOverride} />
    );

    const content = product && <ProductCategoryModalInfo product={product} options={options} />;

    return (
        <ScrollableModalStickyBottom
            title={`${product?.title}`}
            className={styles.wrapper}
            isOpen={product && isOpen}
            onRequestClose={onModalClose}
            showCloseButton={true}
            footerComponent={footerComponent}
        >
            {content}
        </ScrollableModalStickyBottom>
    );
};
